<template>
  <div style="padding-top:30px;">
    <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
      <el-tab-pane label="物流订单信息查询" name="first" />
      <el-tab-pane label="质检报告下载" name="second" />
    </el-tabs>
    <div class="wrapper" v-if="activeName === 'first'">
      <el-form ref="ruleForm" :rules="rules" :inline="true" :model="logisticsForm">
        <el-form-item label="手机号码：" prop="userPhone">
          <el-input v-model="logisticsForm.userPhone" placeholder="请输入手机号码"></el-input>
        </el-form-item>
        <el-form-item label="物流单号：" prop="logisticsNumber">
          <el-input v-model="logisticsForm.logisticsNumber" placeholder="请输入物流单号"></el-input>
        </el-form-item>
        <el-form-item label="客户名称：" prop="userParam">
          <el-input v-model="logisticsForm.userParam" placeholder="请输入客户名称"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onSearch">查询</el-button>
          <el-button type="primary" plain @click="$refs.ruleForm.resetFields()">重置</el-button>
        </el-form-item>
      </el-form>
      <el-table
        :data="logisticsList"
        :header-cell-style="{background:'#ed1847',color:'#fff'}"
        border
        stripe
        style="width: 100%;margin:30px 0 15px;"
      >
        <el-table-column
          prop="logisticsNumber"
          label="物流单号"
          align="center"
        />
        <el-table-column
          prop="logisticsName"
          label="物流公司"
          align="center"
        />
        <el-table-column
          prop="generaNames"
          label="大类名称"
          align="center"
        />
        <el-table-column
          prop="shipmentsTime"
          label="发货时间"
          align="center"
        />
        <el-table-column
          label="下载质检报告"
          align="center"
        >
          <template slot-scope="scope">
            <span style="color: #f35678;cursor:pointer;" @click="handleEdit(scope.$index, scope.row)">{{scope.row.dowloadNum > 0 ? '下载' : ''}}</span>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        @size-change="handleLogChange($event, 'logPageSize')"
        @current-change="handleLogChange($event, 'logPageNo')"
        :current-page="logPageNo"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="logPageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="logTotalRows"
        style="text-align:right;"
      >
      </el-pagination>
    </div>
    <div class="wrapper" v-if="activeName === 'second'">
      <el-form ref="ruleForm1" :inline="true" :model="qualityForm" class="demo-form-inline">
        <el-form-item label="产品名称：" prop="qualityName">
          <el-input v-model="qualityForm.qualityName" placeholder="请输入产品名称"></el-input>
        </el-form-item>
        <el-form-item label="批次号：" prop="qualityBatch">
          <el-input v-model="qualityForm.qualityBatch" placeholder="请输入批次号"></el-input>
        </el-form-item>
        <el-form-item label="所属单位："  prop="qualitySelect" >
        <el-select  v-model="qualityForm.qualitySelect" id="selectID"><el-option value="圣湘生物">圣湘生物</el-option><el-option value="圣维基因">圣维基因</el-option><el-option value="红岸基元">红岸基元</el-option></el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onSubmit()">查询</el-button>
          <el-button type="primary" plain @click="$refs.ruleForm1.resetFields()">重置</el-button>
        </el-form-item>
      </el-form>
      <el-table
        :data="qualityList"
        :header-cell-style="{background:'#ed1847',color:'#fff'}"
        border
        stripe
        style="width: 100%;margin: 30px 0 15px;"
      >
        <el-table-column
          prop="qualityName"
          label="产品名称"
          align="center"
        />
        <el-table-column
          prop="qualityBatch"
          label="批次号"
          align="center"
        />
        <el-table-column
          label="下载质检报告"
          align="center"
        >
          <template slot-scope="scope">
            <span style="color: #f35678;cursor:pointer;" @click="handleEdit1(scope.$index, scope.row)">下载</span>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        @size-change="handleQuaChange($event, 'quaPageSize')"
        @current-change="handleQuaChange($event, 'quaPageNo')"
        :current-page="quaPageNo"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="quaPageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="quaTotalRows"
        style="text-align:right;"
      >
      </el-pagination>
    </div>
  </div>
</template>
<script>
// import axios from 'axios'
import { findPageApi, groupListShipmentsApi } from '@/utils/api.js'
export default {
  data () {
    return {
      activeName: 'first',
      logisticsForm: {
        logisticsNumber: undefined,
        userParam: undefined,
        userPhone: undefined,
        clientSide: 'pc'
      },
      qualityForm: {
        qualityName: undefined,
        qualityBatch: undefined,
        qualitySelect: undefined
      },
      logisticsList: [],
      qualityList: [],
      logTotalRows: 0,
      logPageSize: 10,
      logPageNo: 1,
      quaTotalRows: 0,
      quaPageSize: 10,
      quaPageNo: 1,
      rules: {
        userPhone: [
          { required: true, message: '请输入手机号码', trigger: 'blur' }
        ]
      }
    }
  },
  created () {},
  methods: {
    handleClick (tab, event) {},
    async onSearch () {
      this.$refs.ruleForm.validate(async (valid) => {
        if (valid) {
          const data = await groupListShipmentsApi({
            pageNo: this.logPageNo,
            pageSize: this.logPageSize,
            ...this.logisticsForm
          })
          this.logisticsList = data.rows
          this.logTotalRows = data.totalRows
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    async onSubmit () {
      // 处理多个批次号连在一起
      const data = await findPageApi({
        pageNo: this.quaPageNo,
        pageSize: this.quaPageSize,
        ...this.qualityForm
      })
      this.qualityList = data.rows
      this.quaTotalRows = data.totalRows
    },
    async handleEdit (index, row) {
      if (row.dowloadNum > 0) {
        let token = localStorage.getItem('accessToken')
        window.open(`https://pkm.sansure.com.cn/pc/shipments/downloadPackageQuality?logisticsNumber=${row.logisticsNumber}&token=${token}`)
      }
    },
    async handleEdit1 (index, row) {
      let token = localStorage.getItem('accessToken')
      window.open(`https://pkm.sansure.com.cn/pc/quality/downloadQuality?qualityId=${row.qualityId}&token=${token}`)
    },
    handleLogChange (val, name) {
      this[name] = val
      this.onSearch()
    },
    handleQuaChange (val, name) {
      this[name] = val
      this.onSubmit()
    }
  }
}
</script>
<style scoped>
.wrapper {
  padding: 20px;
}
 .el-tabs__item:hover {
  color:#ed1846;
}
 .el-button--primary {
  background: #ed1846;
  border: 1px solid #ed1846;
}
.el-button--primary.is-plain {
  background: #fae7ec;
  border: 1px solid #f35678;
  color: #ed1846;
}
 .el-tabs__item.is-active {
  color: #ed1846;
}

</style>



// WEBPACK FOOTER //
// src/views/list/index.vue